import React from "react";
import "./searchBar.css";
function SearchBar({ handelSearchBar }) {
  return (
    <div className="serach_bar me-2">
      <form>
        <input
          type="text"
          className="form-control"
          placeholder="Search here"
          onChange={handelSearchBar}
        />
        <button className="btn" type="button">
          <i className="fas fa-search" />
        </button>
      </form>
    </div>
  );
}

export default SearchBar;
